__turbopack_context__.v({
  "close-button": "SandboxIndicator-module__4ARE7q__close-button",
  "not-shown": "SandboxIndicator-module__4ARE7q__not-shown",
  "sandbox-indicator": "SandboxIndicator-module__4ARE7q__sandbox-indicator",
  "sandbox-indicator-panel": "SandboxIndicator-module__4ARE7q__sandbox-indicator-panel",
});
